import { Splide } from "@splidejs/splide";

export function customSplide() {
  if (window.document.body.id === 'top') {
    const slider1 = new Splide('.splide1',{
      // arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      // autoplay: true, //自動再生
      perPage: 3,
      breakpoints: {
        767: {
          perPage: 1,
        },
      },
      gap: "2rem", // ギャップの指定
      // interval: 6000, // 自動再生の間隔
      perMove: 1,
      type: "loop",
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
      speed: 1000, // スライダーの移動時間
    }).mount();
  }
  if (window.document.body.id === 'real-estate' || window.document.body.id === 'car') {
    // メインスライダー
    const main = new Splide(".splide2", {
      type: "fade", // フェード
      pagination: false, // ページネーション非表示
      arrows: false, // 矢印非表示
      autoplay: true, //自動再生
      interval: 2000, // 自動再生の間隔
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
    });
    // サムネイル
    const thumbnails = new Splide(".splide3", {
      type: "loop", // ループさせる
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
      perPage: 3, // サムネイル3枚表示
      pagination: false, // ページネーション非表示
      isNavigation: true, // 他のスライダーのナビゲーションとしてそれぞれのスライドをクリック可能にする
      gap: '1.7rem',
      breakpoints: {
        767: {
          gap: '0.2rem',
        },
      },
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
}
